import { Button, ConfigProvider } from 'antd'
import { twMerge } from "tailwind-merge";
import styles from "../../services/styles";

const { COLORS } = styles

export default function SL_Button({ type = "primary", variant, className, children, ...rest }) {

    function getTokens() {
        let tokenVariant = {}
        switch (variant) {
            case 'secondary': {
                tokenVariant = {
                    colorPrimary: COLORS.BLUE[600],
                }
                break
            }

            case 'close': {
                tokenVariant = {
                    colorPrimary: COLORS.GRAY[500],
                }
                break
            }

            default: tokenVariant = {
                colorPrimary: COLORS.GREEN[600],
            }
        }

        let tokenType = {}
        switch (type) {
            case 'default': {
                tokenType = {
                    colorText: COLORS.GREEN[900],
                    colorBgContainerDisabled: COLORS.GRAY[200],
                    colorTextDisabled: COLORS.GRAY[500],
                    colorIcon: COLORS.GRAY[500],
                }
                break
            }

            case 'primary': {
                tokenType = {
                    colorBgContainerDisabled: COLORS.GRAY[200],
                    colorTextDisabled: COLORS.GRAY[500],
                    colorIcon: COLORS.GRAY[500],
                }
                break
            }

            case 'link': {
                tokenType = {
                    colorLink: COLORS.GREEN[700],
                    colorLinkActive: COLORS.GREEN[600],
                    colorLinkHover: COLORS.GREEN[600],
                }
                break
            }
        }

        return { ...tokenVariant, ...tokenType }
    }

    const classes = twMerge(`
        flex
        justify-center
        items-center
        ${className}
    `)

    return (
        <ConfigProvider
            theme={{
                token: getTokens(),
            }}
        >
            <Button
                type={type}
                {...rest}
                className={classes}
            >
                {children}
            </Button>
        </ConfigProvider>
    )
}
